var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('b-dropdown-item',{directives:[{name:"gk-confirm",rawName:"v-gk-confirm",value:({
    title: _vm.$gettext('Delete permanently?'),
    message: _vm.deleteWarningText,
    options: {
      warning: _vm.warningText,
      item: _vm.itemText + ' - ' + _vm.item.number,
      variant: 'danger',
      confirmText: _vm.$gettext('Delete permanently'),
      safeguard: (_vm.itemType === 'invoice' && _vm.item.status !== 'd'),
      safeguardText: _vm.safeguardText
    },
    callback: _vm.deleteItem,
    callbackParams: _vm.item.id
  }),expression:"{\n    title: $gettext('Delete permanently?'),\n    message: deleteWarningText,\n    options: {\n      warning: warningText,\n      item: itemText + ' - ' + item.number,\n      variant: 'danger',\n      confirmText: $gettext('Delete permanently'),\n      safeguard: (itemType === 'invoice' && item.status !== 'd'),\n      safeguardText: safeguardText\n    },\n    callback: deleteItem,\n    callbackParams: item.id\n  }"}],attrs:{"variant":"danger"}},[_c('font-awesome-icon',{attrs:{"icon":"fa-regular fa-trash-can"}}),_c('span',[_vm._v(_vm._s(_vm.deleteText))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }